import get from 'lodash/get';
import router from '@/router';
import { ORDER_NEW_DATA_MANDATORY_SUPPLIER_FIELDS } from '@/queries/Order';
import { KeysArray } from '@/utils/utils';
import { GQL_orderNewDataMandatorySupplierFields_currentUser_currentUnit } from '@/queries/__generated__/orderNewDataMandatorySupplierFields';

const checkSupplierMandatoryFieldsGuard = () => {
  return new Promise((resolve, reject) => {
    router.app.$apollo
      .query({
        query: ORDER_NEW_DATA_MANDATORY_SUPPLIER_FIELDS,
      })
      .then(({ data }) => {
        const fieldsToCheck: KeysArray<GQL_orderNewDataMandatorySupplierFields_currentUser_currentUnit> = [
          'email',
          'address',
          'zip',
          'city',
        ];
        const allFieldsSet = fieldsToCheck.every(key => {
          const value = get(data.currentUser.currentUnit, key);
          if (typeof value === 'string') return !!value.trim().length;
          return false;
        });
        allFieldsSet ? resolve() : reject(router);
      });
  });
};

export default checkSupplierMandatoryFieldsGuard;
